import { environement } from "../../environements/environement";


export const apiConfig = {
    baseUrl: environement.baseUrl,
};

export const pictureUrl = {
    url: ''
}